import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-7955d7d8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "screen-guide-body"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "no-tips"
  }, "请授权整个屏幕的分享权限", -1);
});
var _hoisted_3 = {
  class: "guide-box"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "no-tips"
  }, "window系统电脑权限设置示例：", -1);
});
var _hoisted_5 = {
  class: "guide-box"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "no-tips"
  }, "mac系统电脑权限设置示例：", -1);
});
var _hoisted_7 = {
  class: "guide-box"
};
import { EnvCheckerService } from '@/services/env/checker.service';
import { useService } from '@kaokei/use-vue-service';
import WinGuideImg from '@/assets/image/envCheck/scree-share-win.png';
import MacGuideImg from '@/assets/image/envCheck/screen-share-mac.png';
import ShareScreen from '@/assets/image/envCheck/share-screen.jpg';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var checkerService = useService(EnvCheckerService);
    return function (_ctx, _cache) {
      var _component_a_image = _resolveComponent("a-image");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        visible: _unref(checkerService).showScreenGuide,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return _unref(checkerService).showScreenGuide = $event;
        }),
        closable: true,
        "destroy-on-close": true,
        "mask-closable": false,
        keyboard: false,
        width: 823,
        footer: null,
        centered: "",
        title: "屏幕分享权限权限引导"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_image, {
            width: 320,
            src: _unref(ShareScreen),
            alt: ""
          }, null, 8, ["src"])]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_image, {
            width: 750,
            src: _unref(WinGuideImg),
            alt: ""
          }, null, 8, ["src"])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_image, {
            width: 750,
            src: _unref(MacGuideImg),
            alt: ""
          }, null, 8, ["src"])])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
});